import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import PricingStrip from "@/components/PricingStrip";
import Features from "@/components/Features";
import AIInsights from "@/components/AIInsights";
import FounderNote from "@/components/FounderNote";
import FAQ from "@/components/FAQ";
import Footer from "@/components/Footer";
import EditToolbar from "@/components/EditToolbar";
import { ContentProvider } from "@/lib/ContentContext";

export default function LandingPage() {
  return (
    <ContentProvider>
      <main className="min-h-screen bg-[#F4ECFF] text-[#0B0A4A] font-sans" data-testid="landing-page">
        <Nav />
        <Hero />
        <PricingStrip />
        <Features />
        <AIInsights />
        <FounderNote />
        <FAQ />
        <Footer />
        <EditToolbar />
      </main>
    </ContentProvider>
  );
}
